import './AppPageBody.scss';
import React from 'react';
import classNames from 'classnames';
import ErrorBoundary from '../ErrorBoundary';
import Loader from '../loader';

export type AppPageBodyProps = React.HTMLAttributes<HTMLDivElement> & {
  loading?: boolean;
};

export default function AppPageBody(props: AppPageBodyProps) {
  return (
    <ErrorBoundary>
      <div className={classNames('app-page-body', { [props.className]: !!props.className })}>
        <>
          <Loader isLoading={!!props.loading} />
          {!props.loading && props.children}
        </>
      </div>
    </ErrorBoundary>
  );
}
